import { Box, Link, Typography } from "@mui/material";
import { formatAED } from "../utils/format";

const ADMIN_ROLE_IDS = [295, 377];

const currentUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch (e) {
    return {};
  }
};

// Same rule as the server: the document's creator or an Admin manages payments.
export const canManageDocPayments = (row) => {
  const u = currentUser();
  return ADMIN_ROLE_IDS.includes(Number(u?.role_id)) || Number(row?.created_by) === Number(u?.emp_id);
};

const isOpenDoc = (row) => ["active", "partial_returned"].includes(String(row?.status || "active"));

// "Received" cell of the CDN / Proforma lists: the amount, right-aligned like
// the other money columns, with a clear "Payments" / "+ Add payment" link under
// it — so nobody has to guess that payments can be opened from here.
export default function PaymentsCell({ row, onOpen }) {
  const received = Number(row?.advance_received || 0);
  const stop = (e) => e.stopPropagation();
  const open = (e) => {
    stop(e);
    onOpen(row);
  };
  const linkSx = { fontSize: 11.5, fontWeight: 600, lineHeight: 1.3, cursor: "pointer" };

  if (received > 0) {
    return (
      <Box data-lmggt-handled="true" onClick={stop} sx={{ textAlign: "right", lineHeight: 1.3 }}>
        <Typography component="div" sx={{ fontSize: 13, fontWeight: 600, color: "#15803d" }}>
          {formatAED(received)}
        </Typography>
        <Link component="button" type="button" underline="hover" onClick={open} sx={linkSx}>
          View payments
        </Link>
      </Box>
    );
  }

  if (isOpenDoc(row) && canManageDocPayments(row)) {
    return (
      <Box data-lmggt-handled="true" onClick={stop} sx={{ textAlign: "right" }}>
        <Link component="button" type="button" underline="hover" onClick={open} sx={{ ...linkSx, color: "text.secondary" }}>
          + Add payment
        </Link>
      </Box>
    );
  }
  return (
    <Typography component="div" sx={{ textAlign: "right", color: "#9ca3af", fontSize: 13 }}>
      -
    </Typography>
  );
}
